import script from "./SideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBar.vue?vue&type=script&setup=true&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=67d0b684&scoped=true&lang=scss"

import exportComponent from "/builds/smartdevops/viccarbe/viccarbe-professional-area/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67d0b684"]])

export default __exports__